import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
const image1 = require("../../images/about1.jpg")

//   const images = [
//   require("./../../images/about-slider/1.jpg"),
//   require("./../../images/about-slider/2.jpg"),
//   require("./../../images/about-slider/3.jpg"),
//   require("./../../images/about-slider/4.jpg"),
//   require("./../../images/about-slider/5.jpg"),
// ];
const images = [image1];

var bgimg1 = require("./../../images/background/bg-transparent.png");
var bgimg2 = require("./../../images/background/cross-line2.png");

class About1 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: true,
      margin: 30,
      nav: true,
      dots: true,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        991: {
          items: 1,
        },
      },
    };
    return (
      <>
        <div
          className="section-full mobile-page-padding p-t80 p-b80 bg-white bg-no-repeat bg-bottom-left"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container">
            {/* TITLE START */}
            {/* <div  data-aos-duration="800"  data-aos="fade-up" className="section-head">
              <div className="sx-separator-outer separator-left">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  // style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                >
                  <h3 className="sep-line-one">Qui sommes-nous</h3>
                </div>
              </div>
            </div> */}
            {/* TITLE END */}
            <div className="section-content">
              <div className="row">
                <div data-aos-duration="800"  data-aos="fade-right" className="col-lg-5 col-md-12 col-sm-12">
                  <div className="about-home-left">
                    <h3 className="m-t0 sx-tilte">Association La vallée</h3>
                    <p>
                      LA VALLEE, une association constituée conformément aux
                      dispositions du Dahir n° 1-58-371 du 15 Novembre 1958, tel
                      qu’il a été modifié et complété.
                    </p>
                    <p>
                      L’association LAVALLEE a été créée à l’initiative de
                      cadres supérieurs relevant de plusieurs secteurs
                      d’activités (public, privé, fonctions libérales,…….).
                    </p>
                    <div className="text-left">
                      <NavLink
                        to="/about-1"
                        className="site-button-secondry btn-half"
                      >
                        <span>Voir plus</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
                <div  data-aos-duration="800"  data-aos="fade-left" className="col-lg-7 col-md-12 col-sm-12">
                  <div className="about-home-right">
                    {/* <OwlCarousel
                      className="owl-carousel about-home number-slider owl-btn-vertical-center"
                      {...options}
                    > */}
                    {images.map((item, index) => (
                      <div className="item" key={index}>
                        <div style={{ width: '360px' }} className="sx-img-effect">
                            <img
                              style={{
                                width: "360px",
                                height: "477px",
                                objectFit: "cover",
                              }}
                              src={item}
                              alt=""
                            />
                        </div>
                      </div>
                    ))}
                    {/* </OwlCarousel> */}
                    <div className="about-home-before">
                      <img
                        src={require("../../images/about2.jpg")}
                        alt=""
                        style={{
                          width: "360px",
                          height: "477px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>association <br/>la vallée</strong>
          </div>
        </div>
      </>
    );
  }
}

export default About1;
